export type SeuPagination = {
  currentPage: number;
  itemsPerPage: SeuPageSize;
  totalItems: number;
};

export type SeuPageSize = 6 | 10 | 20 | 30 | 100;
export const SEU_PAGINATION_PAGE_SIZES: SeuPageSize[] = [6, 10, 20, 30, 100];
export const SEU_PAGINATION_DEFAULT_ITEMS_PER_PAGE: SeuPageSize = 6;
